import { post } from '@namespace/helpers';
import apiRoutes from './apiRoutes';

export const getZendeskChatUser = () => post(apiRoutes.getZendeskChatUser, {});

export const getZendeskClassicChatUser = () =>
  post(apiRoutes.getZendeskClassicChatUser, {});
